import { useEffect } from 'react';
import { animated, useSpring } from "react-spring";

function Folder(props) {

  const [fr, api1] = useSpring(() => ({
    from: {
      d: "m 960,44 c 467,0 434.6229,0.0023 870,4.5e-5 15.0207,-8e-5 20.0207,4.99992 20.0207,19.99992 v 15 c 0,10 69.9793,12.00008 69.9793,24.000085 v 256.99999 c 0,10 -69.9793,13.99992 -69.9793,23.99992 l -0.021,580.00008 c -5e-4,15 -5,20 -20,20 -15,0 -419.9994,10e-6 -869.9997,-4e-5 z",
      stopColor: "#EAC24D",
      shadowOffset: "0%",
      offset: "100%",
      stopColorShadow: "#EAC24D",

    },
    config: { duration: 400 },
    delay: 4000,
    onRest: () => { props.open(true) }
  }))

  const [fl, api2] = useSpring(() => ({
    from: {
      d: "m 960,43.99995 c 432,0 434.6022,0.0024 869.9793,1.35e-4 15.0207,-9e-5 20.0207,4.99991 20.0207,19.99991 v 358.999995 c 0,10 70,12 70,24 v 488 c 0,10 -70,17 -70,30 0,13 -4,19.0001 -20,19.0001 -15,0 -415,-1.4e-4 -870,-1.4e-4 z",
      stopColor: "#EAC24D",
      shadowOffset: "0%",
      offset: "100%",
      stopColorShadow: "#EAC24D",
    },
    delay: 4000,
    config: { duration: 400 },
    // need fallback case for componenets loading regardless
    onRest: () => { props.open(true) }
  }))

  const [moveAndRotate, mrApi] = useSpring(() => ({
    from: {
      transform: 'rotate(0.05rad) ',
      // 24% instead of 25% because the rotation makes it look off center
      x: "-24%",
    },
    delay: 4000,
    config: { duration: 400 },
    onRest: () => startOpen()
  }))


  function startOpen() {
    api1.start({
      d: "m 960,92 c 472.8647,-23.643233 434.6229,-27.997715 870,-28 15.0207,-7.9e-5 20.0207,4.999921 20.0207,19.999921 v 15 c 0,9.999999 69.9793,12.000079 69.9793,24.000079 v 257 c 0,10 -69.9793,13.99992 -69.9793,23.99992 l -0.021,580.00008 c -5e-4,15 -5,20 -20,20 -15,0 -414,0 -870,24 z",
      stopColor: "#EAC24D",
      shadowOffset: "5%",
      antioffsetOffset: "95%",
      stopColorShadow: "#C7A65F",
    });
    api2.start({
      d: "m 960,91.999914 c -472.8647,-23.64323 -434.60221,-27.997539 -869.9793,-27.999829 -15.0207,-8e-5 -20.0207,4.99992 -20.0207,19.999919 v 358.999996 c 0,10 -70,12 -70,24 v 488 c 0,10 70,17 70,30 0,13 4,19.0001 20,19.0001 15,0 414,-10e-5 870,23.9999 z",
      stopColor: "#EAC24D",
      shadowOffset: "10%",
      offset: "90%",
      stopColorShadow: "#C7A65F",
    });
  }

  useEffect(() => {
    if (props.begin)
      mrApi.start({
        transform: 'rotate(0rad) ',
        x: "0%",
        rotate: '',
        y: 0,
      });
  }, [props.begin, mrApi])

  return (
    <div className="lg-folder-container absolute w-full h-full flex items-center justify-center">
      {/* Main container */}
      <div className='relative w-full h-full mx-2 2xl:w-5/6'>
        {/* SVG Background Layer - Place it first but with lower z-index */}
        <div className="absolute inset-0 flex items-center justify-center -z-10">
          <div className="relative w-full h-full">
            <animated.div
              className="hidden lg:block folder-open absolute w-full h-full"
              // style={{ transform: moveAndRotate.transform, y: moveAndRotate.y }} 
              id="fr"
            >
              <svg className='w-full h-full'
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 1920 1080"
                preserveAspectRatio='xMidYMid meet'
                style={{ filter: "url(#shadow) url(#right-inner-shadow)" }}
              >
                <animated.svg x={moveAndRotate.x} style={{ transform: moveAndRotate.transform }}>
                  <defs>
                    <linearGradient id="rightFill">
                      <animated.stop offset={fr.shadowOffset}
                        stopColor={fr.stopColorShadow} />
                      <animated.stop offset={fr.offset}
                        stopColor="#EAC24D" />
                    </linearGradient>
                  </defs>
                  <animated.path
                    d={fr.d}
                    fill="url(#rightFill)"
                    id="rightPath"
                    className={"folderPath"}
                  ></animated.path>
                  <filter id="shadow">
                    <feDropShadow dx="0" dy="0" stdDeviation="20" floodOpacity="0.7" />
                  </filter>
                  <filter id="right-inner-shadow">
                    <feOffset
                      dx='300'
                      dy='0'
                    />
                    <feGaussianBlur
                      stdDeviation='200'
                      result='offset-blur'
                    />
                    <feComposite
                      operator='out'
                      in='SourceGraphic'
                      in2='offset-blur'
                      result='inverse'
                    />
                    <feFlood
                      floodColor='black'
                      floodOpacity='.15'
                      result='color'
                    />
                    <feComposite
                      operator='in'
                      in='color'
                      in2='inverse'
                      result='shadow'
                    />
                    <feComposite
                      operator='over'
                      in='shadow'
                      in2='SourceGraphic'
                    />
                  </filter>
                </animated.svg>
              </svg>
            </animated.div>
            {/* can set z index here */}
            <animated.div
              className="hidden lg:block folder-open absolute w-full h-full"
              id="fl"
            >
              <svg className='w-full h-full' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1920 1080" preserveAspectRatio='xMidYMid meet' style={{ filter: "url(#shadow) url(#left-inner-shadow)" }}>
                <animated.svg x={moveAndRotate.x} style={{ transform: moveAndRotate.transform }}>
                  <defs>
                    <linearGradient id="leftFill">
                      <animated.stop offset={fl.shadowOffset}
                        stopColor="#EAC24D" />
                      <animated.stop offset={fl.offset}
                        stopColor={fl.stopColorShadow} />
                    </linearGradient>
                  </defs>
                  <animated.path
                    d={fl.d}
                    id="leftPath"
                    fill="url(#leftFill)"
                    className={"folderPath"}
                  ></animated.path>
                  <filter id="left-inner-shadow">
                    <feOffset
                      dx='-200'
                      dy='0'
                    />
                    <feGaussianBlur
                      stdDeviation='300'
                      result='offset-blur'
                    />
                    <feComposite
                      operator='out'
                      in='SourceGraphic'
                      in2='offset-blur'
                      result='inverse'
                    />
                    <feFlood
                      floodColor='black'
                      floodOpacity='.05'
                      result='color'
                    />
                    <feComposite
                      operator='in'
                      in='color'
                      in2='inverse'
                      result='shadow'
                    />
                    <feComposite
                      operator='over'
                      in='shadow'
                      in2='SourceGraphic'
                    />
                  </filter>
                </animated.svg>
              </svg>
            </animated.div>
          </div>
        </div>
        <div id="folderChild" className="relative w-full h-full flex items-center justify-center">
          <div className='flex items-center justify-center h-full w-full'>
            {props.children}
          </div>
        </div>
      </div>
      {/* folder closed for small screens */}
      <animated.div className="align-middle folder-closed w-full absolute md:p-0 top-5 z-0 h-full folder-small mr-1 overflow-hidden md:mt-0 -mt-16" id="frClosed">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 980 943" preserveAspectRatio='xMaxYMax slice' style={{ width: "100%", height: "100%" }}>
          <svg style={{ width: "100%", height: "100%" }}>
            {/* <filter id="bottomSmallFolderShadow" width="120" height="120">
              <feDropShadow dx="18" dy="18" stdDeviation="2" floodOpacity="0.3" />
            </filter> */}
            <animated.path
              d="m 11.500601,44.00005 c 455.811409,0 424.210009,0.0023 849.156199,4.5e-5 14.6608,-8e-5 19.541,4.99992 19.541,19.99992 v 15 c 0,10 68.3027,12.00008 68.3027,24.000085 v 256.99999 c 0,10 -68.3027,13.99992 -68.3027,23.99992 l -0.021,580.00008 c -5e-4,15 -4.8803,20 -19.5209,20 -14.6407,0 -409.9369,10e-6 -849.155899,-4e-5 z"
              fill="#EAC24D"
              id="rightPathClosed"
              className={"folderPath"}
              filter="url(#bottomSmallFolderShadow)"
            ></animated.path>
          </svg>
        </svg>
      </animated.div>
      <animated.div className="align-middle folder-closed w-full absolute md:p-0 top-5 z-0 h-full folder-small mr-1 overflow-hidden md:mt-0 -mt-16" id="flClosed" >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 980 943" preserveAspectRatio='xMaxYMax slice' style={{ width: "100%", height: "100%" }}>
          <svg style={{ width: "100%", height: "100%" }}>
            {/* <filter id="topSmallFolderShadow" width="120" height="120">
              <feDropShadow dx="7" dy="7" stdDeviation="2" floodOpacity="0.3" />
            </filter>
            <filter id='inset-shadow'>
              <feOffset
                dx='100'
                dy='-50'
              />
              <feGaussianBlur
                stdDeviation='75'
                result='offset-blur1'
              />
              <feComposite
                operator='out'
                in='SourceGraphic'
                in2='offset-blur1'
                result='inverse'
              />
              <feFlood
                floodColor='black'
                floodOpacity='.5'
                result='color'
              />
              <feComposite
                operator='in'
                in='color'
                in2='inverse'
                result='topShadow'
              />
              <feComposite
                operator='over'
                in='topShadow'
                in2='topSmallFolderShadow'
                result='mixedShadow'
              />
              <feComposite
                operator='over'
                in='mixedShadow'
                in2='SourceGraphic'
              />
            </filter> */}
            <animated.path
              d="m 11.500601,44 c 421.649959,0 424.189809,0.0024 849.135899,1.35e-4 14.6609,-9e-5 19.5411,4.99991 19.5411,19.99991 v 358.999995 c 0,10 68.3229,12 68.3229,24 v 488 c 0,10 -68.3229,17 -68.3229,30 0,13 -3.9041,19.0001 -19.5208,19.0001 -14.6407,0 -405.05729,-1.4e-4 -849.156199,-1.4e-4 z"
              id="leftPathClosed"
              fill="#EAC24D"
              className={"folderPath"}
              filter="url(#topSmallFolderShadow) url(#inset-shadow)"
            ></animated.path>
          </svg>
        </svg>
      </animated.div>
    </div>
  );
}

export default Folder;
